<template>
  <div>
    <div class="flex flex-wrap">
      <div class="w-full xl:w-6/12 mb-4 xl:mb-0 px-2">
        <card-chart-image v-bind:image_link="chart.image_link" />
      </div>
      <div class="w-full xl:w-6/12 px-2">
        <card-chart-description
          :name="chart.name"
          :description="chart.description"
        />
      </div>
    </div>
    <div class="flex flex-wrap mt-4">
      <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
        <card-charts :data_link="this.id" :tag="chart.tag" />
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: Chart
  Description: This class representing a main entry point for chart.
*/

/* Imports */
import ChartService from "@/services/chart.service.js";
import CardChartImage from "@/components/Cards/Charts/CardChartImage.vue";
import CardChartDescription from "@/components/Cards/Charts/CardChartDescription.vue";
import CardCharts from "@/components/Cards/Charts/CardCharts.vue";
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: '%s | ' + this.$route.name
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    CardChartImage,
    CardChartDescription,
    CardCharts,
  },

  /* 
    Define props from which we got chart. 
  */
  props: {
    chart: null,
    id: null
  },

  /* 
    Define watcher from which we got data for specified chart. 
  */
  watch: {
    "$route.params.id": {
      handler: function(id) {
        ChartService.getChart(id).then((response) => {
          this.chart = response;
          this.id = id
          localStorage.setItem('value_type', response.value_type);
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
